/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Phone number input for user creation
 * @export
 * @interface PhoneNumberInput
 */
export interface PhoneNumberInput {
    /**
     * Phone number in E.164 format (e.g., +1-202-555-0173, +44-20-7946-0958)
     * @type {string}
     * @memberof PhoneNumberInput
     */
    phoneNumber: string;
    /**
     * Type of phone number
     * @type {string}
     * @memberof PhoneNumberInput
     */
    type?: PhoneNumberInputTypeEnum;
    /**
     * Whether this is the primary phone number (only one should be primary)
     * @type {boolean}
     * @memberof PhoneNumberInput
     */
    isPrimary?: boolean;
    /**
     * Optional label/description for the phone number
     * @type {string}
     * @memberof PhoneNumberInput
     */
    label?: string;
}


/**
 * @export
 */
export const PhoneNumberInputTypeEnum = {
    Mobile: 'MOBILE',
    Work: 'WORK',
    Home: 'HOME',
    Other: 'OTHER'
} as const;
export type PhoneNumberInputTypeEnum = typeof PhoneNumberInputTypeEnum[keyof typeof PhoneNumberInputTypeEnum];


/**
 * Check if a given object implements the PhoneNumberInput interface.
 */
export function instanceOfPhoneNumberInput(value: object): value is PhoneNumberInput {
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    return true;
}

export function PhoneNumberInputFromJSON(json: any): PhoneNumberInput {
    return PhoneNumberInputFromJSONTyped(json, false);
}

export function PhoneNumberInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneNumberInput {
    if (json == null) {
        return json;
    }
    return {
        
        'phoneNumber': json['phoneNumber'],
        'type': json['type'] == null ? undefined : json['type'],
        'isPrimary': json['isPrimary'] == null ? undefined : json['isPrimary'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function PhoneNumberInputToJSON(json: any): PhoneNumberInput {
    return PhoneNumberInputToJSONTyped(json, false);
}

export function PhoneNumberInputToJSONTyped(value?: PhoneNumberInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phoneNumber': value['phoneNumber'],
        'type': value['type'],
        'isPrimary': value['isPrimary'],
        'label': value['label'],
    };
}

